/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/steve_ui_core").IconRegistry;

IconRegistry.registerIcon("wizard.wizardExplorer", require("./rawicons/wizard/wizardExplorer.icon.svg.js"));
